import React from 'react';
import { useStore } from '../context/StoreContext';
import Link from './Link';
import { shopPath } from '../utils/slug';
import './Footer.css';

export default function Footer() {
  const { navigate, goShop, openWA, catNames } = useStore();

  /* Collection links follow whatever categories actually exist.
     Capped at six so a long catalogue does not stretch the column. */
  const collections = catNames.slice(0, 6);

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-brand-name">CITY SHOPPING CENTER</div>
            <p>Premium artificial jewelry American Diamond, Zircon & Fancy collections for every occasion. Trusted by families since 2001.</p>
            <div className="footer-est">Est. 2001 · Shop# 23, Touseef Market, Daska, Pakistan</div>
          </div>
          {collections.length > 0 && (
            <div className="footer-col">
              <h4>Collections</h4>
              {collections.map((c) => (
                <Link key={c} href={shopPath(c)} className="footer-link" onClick={() => goShop(c)}>
                  {c}
                </Link>
              ))}
            </div>
          )}
          <div className="footer-col">
            <h4>Info</h4>
            <Link href="/about" className="footer-link" onClick={() => navigate('about')}>About Us</Link>
            <Link href="/contact" className="footer-link" onClick={() => navigate('contact')}>Contact</Link>
            <Link href="/blog" className="footer-link" onClick={() => navigate('blog')}>Blog & Guides</Link>
            <button className="footer-link" onClick={openWA}>WhatsApp Us</button>
          </div>
          <div className="footer-col">
            <h4>Legal</h4>
            <Link href="/privacy-policy" className="footer-link" onClick={() => navigate('privacy-policy')}>Privacy Policy</Link>
            <Link href="/terms" className="footer-link" onClick={() => navigate('terms')}>Terms & Conditions</Link>
          </div>
        </div>
        <div className="footer-copy">
          © 2026 City Shopping Center & Dulha House. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
